<template>
    <div class="container">
        <div style="margin: 60px 0 20px;  color: rgb(30, 139, 195);font-weight: 500;font-size: 32px;">
            <span>История проверок</span>
        </div>
        <adminFilters v-if="admin" adminType="check_fl" :onFilterCallback="getHistory" @admin-request="adminRequest" @history-refresh="historyRefresh"/>
        <pagination v-if="pagination && history.length" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
        <table class="history__table">
            <thead>
                <tr>
                    <th>Дата и время</th>
                    <th v-if="admin">Пользователь</th>
                    <th>Результат проверки</th>
                </tr>
            </thead>
            <tbody v-if="history && history.length">
                <tr v-for="(e,i) in history" :key="i">
                    <td>{{e.date ? e.date.slice(0,e.date.length - 3) : '—'}}</td>
                    <td v-if="admin">
                        {{e.user_name}}<br>
                        {{e.user_login ? `(${e.user_login})` : ''}}
                    </td>
                    <td>
                        <div v-if="e.request_params">
                            <a @click="sendData(e.request_params, e)" class="blue-red-hover-text">{{e.name ? e.name : '—'}}</a>
                            {{e.request_params.birthday ? `(${parseDate(e.request_params.birthday)})` : ''}}
                            {{e.request_params.number && e.request_params.serial ? `Паспорт: ${e.request_params.serial} ${e.request_params.number}` : ''}}
                            {{e.request_params.inn ? `ИНН: ${e.request_params.inn}` : ''}}
                        </div>
                        <div v-else>
                            <span>{{e.name ? e.name : '—'}}</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination v-if="pagination && history.length" :pagination="pagination" :onTurnPageCallBack="getHistory" :showRowsPerPageSelection="false" :rows_on_page="history.length"/>
        <pdf v-show="request" :dateCheck="dateCheck" :list="response" :upload="upload" :name="request.name ? request.name : ''" :surname="request.surname ? request.surname : ''" :patronymic="request.patronymic ? request.patronymic : ''" :birthday="request.birthday ? request.birthday : ''" :serial="request.serial ? request.serial : ''" :number="request.number ? request.number : ''" :inn="request.inn ? request.inn : checkedInn" :inputInn="request.inn ? request.inn : ''" ref="checkPdf" :key="componentKey"/>
    </div>
</template>

<script>
import pagination from '@/components/ui/pagination.vue'
import axios from 'axios'
import pdf from '@/components/rosseti/visitorFLCheckCombined/flCheck/flCheckPdf.vue'
import adminFilters from '@/components/ui/adminFilters.vue'

export default {
    components: {
        pagination,
        pdf,
        adminFilters
    },
    data() {
        return {
            dateCheck: Date.now(),
            checkbox: true,
            searchQuery: '',
            users: '',
            date_from: '',
            date_to: '',
            response: {},
            request: {},
            readyForDownload: false,
            checkedInn: '',
            componentKey: 0,
            alexnderCheckbox: true,
            searchQuery: '',
            users: [],
            date_from: '',
            date_to: '',
        }
    },
    mounted() {
        this.getHistory()
    },
    computed: {
        admin() { return this.$store.state.user?.groups?.filter(e => e.rules.adm_check_fl)?.length },
        user() { return this.$store.state.flCheck?.user },
        pagination() { return this.$store.state.flCheck?.pagination },
        upload() { return this.$store.state.flCheck?.upload },
        history() { return this.$store.state.flCheck?.history }
    },
    methods: {
        setCheckbox(value) {
            this.checkbox = value
        },
        getHistory(
            offset = 0,
            limit = 50,
            searchQuery = this.searchQuery,
            users = this.users,
            date_from = this.date_from,
            date_to = this.date_to,
            show_adm =  this.alexnderCheckbox
        ) {
            this.users = users
            this.$store.dispatch('flCheck/getHistory', { offset, limit, searchQuery, users, date_from, date_to, show_adm })
        },
        adminRequest(value){
            this.alexnderCheckbox = value
        },
        parseDate(date) {
            if(date) {
                if(isNaN(Date.parse(date))) {
                    return date
                } else {
                    return new Date(date).toLocaleDateString('ru')
                }
            } else {
                return '—'
            }
        },
        sendData(req, res) {
            this.$store.commit('flCheck/setUpload', false)
            this.$store.commit('flCheck/setLoading', true)
            this.request = req
            this.response = res.response.data
            this.dateCheck = res.date.slice(0, 10) ?? Date.now() 
                       
            if(res?.check_inn?.data?.inn) {
                this.checkedInn = res?.check_inn?.data?.inn
            }
            console.log(this)
            this.componentKey += 1
            if(this.$refs.checkPdf) {
                setTimeout(() => {
                    this.$refs.checkPdf.getPdf()
                    document.querySelector(".fl-pdf").style.display = "none"
                }, 5500)
            }
        },
        historyRefresh() {
            this.history.searchQuery = ''
            this.history.users = ''
            this.history.date_from = ''
            this.history.date_to = ''
            this.getHistory()
        }
    }

}
</script>

<style lang="sass" scoped>
@import "styles/global-variables.sass"

.history
    &__header
        margin-top: 20px
        color: rgb(30, 139, 195)
        font-weight: 500
        font-size: 32px
    &__table
        width: 100%
        text-align: left
        font-size: 14px
        th
            font-weight: 600
            padding: 10px 0
        td
            padding: 5px 0
            font-weight: 400
.blue
    color: #1e8bc3
    cursor: pointer
</style>